module.exports = __webpack_public_path__ + "6af60a716a265c9e9c9213b46245a317.pdf";